"use strict";
/*
 * Copyright (C) 2017-2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleSetDataFilter = void 0;
/**
 * An [[OmvFeatureFilter]] implementation that queries [[StyleSetEvaluator]]
 * if given layers/features should be processed.
 *
 * Used in [[OmvDecoder]] to skip processing of layers/features that doesn't
 * have associated rules in style.
 *
 * @see [[StyleSetEvaluator.wantsFeature]]
 * @see [[StyleSetEvaluator.wantsLayer]]
 */
class StyleSetDataFilter {
    constructor(styleSetEvaluator) {
        this.styleSetEvaluator = styleSetEvaluator;
        this.hasKindFilter = false;
    }
    wantsLayer(layer, level) {
        return this.styleSetEvaluator.wantsLayer(layer);
    }
    wantsPointFeature(layer) {
        return this.styleSetEvaluator.wantsFeature(layer, "point");
    }
    wantsLineFeature(layer) {
        return this.styleSetEvaluator.wantsFeature(layer, "line");
    }
    wantsPolygonFeature(layer) {
        return this.styleSetEvaluator.wantsFeature(layer, "polygon");
    }
    wantsKind() {
        return true;
    }
}
exports.StyleSetDataFilter = StyleSetDataFilter;
//# sourceMappingURL=StyleSetDataFilter.js.map